// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"v3-z","displaySixCardTiles":"w3-z"};